import {
  mustBeEmail,
  mustBeFilled,
  mustBeLessThan,
  mustBeMoreThan,
  mustMatch,
} from '../../libs/validators';

export const inputEmailValidConfig = {
  autoComplete: 'email',
  description: 'Exemple : jean.dupont@orange.fr',
  label: 'Confirmer votre adresse électronique',
  name: 'emailValid',
  validators: {
    format: [
      mustBeMoreThan(3),
      mustBeLessThan(256),
      mustBeEmail('Veuillez saisir une adresse électronique valide'),
      mustMatch('email', 'Les adresses email ne correspondent pas'),
    ],
    submit: mustBeFilled('Veuillez saisir une adresse email'),
  },
};
